<template>
    <div class="about-area" id="sobre">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="section-title text-center">
                        <h1>Sobre o <span>Software</span></h1>
                        <p>Este é um sistema de gestão online que atende pequenas e médias empresas que trabalham com vendas de produtos e/ou prestações de serviços.
                        <br />
                        Com o nosso sistema ERP online você pode controlar, em um só lugar, o financeiro, o setor de vendas, compras, estoque e todos os demais departamentos da sua empresa em um único software de forma rápida, simples e intuitiva. </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>